import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/ats-resume-checker/ATSScannerContent.tsx");
